/**
 * Adapter to convert a11y-wizard's AltImageRuleProps to the shared AltImageRuleProps format.
 */

import { AltImageStatus, convertElementStatusToBooleanStatus, ElementStatus } from '@wix/rules-panel-ui';
/**
 * Convert ElementStatus + isDecorative to AltImageStatus
 */
export const elementStatusToAltImageStatus = function (status, isDecorative, isLinked) {
  if (isLinked === void 0) {
    isLinked = false;
  }
  if (isDecorative && !isLinked) {
    return AltImageStatus.Decorative;
  }
  if (status === ElementStatus.Generated || status === ElementStatus.GeneratedAll) {
    return AltImageStatus.Fixed;
  }
  const isPassed = convertElementStatusToBooleanStatus(status);
  return isPassed ? AltImageStatus.Valid : AltImageStatus.Invalid;
};

/**
 * Adapt a single wizard AltImageRuleProps to the shared format
 */
export const adaptWizardAltImagePropToShared = wizardProps => ({
  altText: wizardProps.alt ?? '',
  componentId: wizardProps.componentId,
  id: wizardProps.id,
  isDecorative: wizardProps.isDecorative,
  isLinked: wizardProps.isLinked,
  status: elementStatusToAltImageStatus(wizardProps.status, wizardProps.isDecorative, wizardProps.isLinked),
  url: wizardProps.url
});

/**
 * Adapt an array of wizard AltImageRuleProps to the shared format
 */
export const adaptWizardAltImagePropsToShared = wizardPropsArray => wizardPropsArray.map(adaptWizardAltImagePropToShared);
//# sourceMappingURL=adapt-wizard-props.js.map